/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Standings_Help_PublicInputs */



/**
* | output |
* | --- |
* | "Players see the full standings at all times." |
*
* @param {Tfield_Standings_Help_PublicInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_standings_help_public = /** @type {((inputs?: Tfield_Standings_Help_PublicInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Standings_Help_PublicInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les joueurs voient toujours le classement complet.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los jugadores ven siempre la clasificación completa.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Os jogadores veem sempre a classificação completa.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I giocatori vedono sempre la classifica completa.")
	return /** @type {LocalizedString} */ ("Players see the full standings at all times.")
});